export default "__VITE_ASSET__xMSiQbGu__"